/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { AddLog$Params, addLog } from '../fn/log/add-log';
import { GetLogs2$Params, getLogs2 } from '../fn/log/get-logs-2';
import { GetLogsGrabber$Params, getLogsGrabber } from '../fn/log/get-logs-grabber';
import { GetLogsTiles$Params, getLogsTiles } from '../fn/log/get-logs-tiles';
import { PostLog$Params, postLog } from '../fn/log/post-log';
import { PutLog$Params, putLog } from '../fn/log/put-log';
import { JobLog } from '../models/job-log';
import { Log } from '../models/log';
import { PagedLogList } from '../models/paged-log-list';

/**
 * Logs API
 */
@Injectable({ providedIn: 'root' })
export class LogService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getLogs2()` */
   static readonly GetLogs2Path = '/api/log/allLogs';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getLogs2()` instead.
    *
    * This method doesn't expect any request body.
    */
   getLogs2$Response(params?: GetLogs2$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedLogList>> {
      return getLogs2(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getLogs2$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getLogs2(params?: GetLogs2$Params, context?: HttpContext): Observable<PagedLogList> {
      return this.getLogs2$Response(params, context).pipe(
         map((r: StrictHttpResponse<PagedLogList>): PagedLogList => r.body)
      );
   }

   /** Path part for operation `putLog()` */
   static readonly PutLogPath = '/api/weather/log/{id}/userInfo';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `putLog()` instead.
    *
    * This method doesn't expect any request body.
    */
   putLog$Response(params: PutLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Log>>> {
      return putLog(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `putLog$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   putLog(params: PutLog$Params, context?: HttpContext): Observable<Array<Log>> {
      return this.putLog$Response(params, context).pipe(map((r: StrictHttpResponse<Array<Log>>): Array<Log> => r.body));
   }

   /** Path part for operation `postLog()` */
   static readonly PostLogPath = '/api/weather/log/{id}/userInfo';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `postLog()` instead.
    *
    * This method doesn't expect any request body.
    */
   postLog$Response(params: PostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Log>>> {
      return postLog(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `postLog$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   postLog(params: PostLog$Params, context?: HttpContext): Observable<Array<Log>> {
      return this.postLog$Response(params, context).pipe(
         map((r: StrictHttpResponse<Array<Log>>): Array<Log> => r.body)
      );
   }

   /** Path part for operation `addLog()` */
   static readonly AddLogPath = '/api/weather/log/{id}/userInfo';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `addLog()` instead.
    *
    * This method doesn't expect any request body.
    */
   addLog$Response(params: AddLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Log>>> {
      return addLog(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `addLog$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   addLog(params: AddLog$Params, context?: HttpContext): Observable<Array<Log>> {
      return this.addLog$Response(params, context).pipe(map((r: StrictHttpResponse<Array<Log>>): Array<Log> => r.body));
   }

   /** Path part for operation `getLogsGrabber()` */
   static readonly GetLogsGrabberPath = '/api/weather/log/grab';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getLogsGrabber()` instead.
    *
    * This method doesn't expect any request body.
    */
   getLogsGrabber$Response(
      params?: GetLogsGrabber$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Array<JobLog>>> {
      return getLogsGrabber(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getLogsGrabber$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getLogsGrabber(params?: GetLogsGrabber$Params, context?: HttpContext): Observable<Array<JobLog>> {
      return this.getLogsGrabber$Response(params, context).pipe(
         map((r: StrictHttpResponse<Array<JobLog>>): Array<JobLog> => r.body)
      );
   }

   /** Path part for operation `getLogsTiles()` */
   static readonly GetLogsTilesPath = '/api/weather/log/tiles';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getLogsTiles()` instead.
    *
    * This method doesn't expect any request body.
    */
   getLogsTiles$Response(
      params?: GetLogsTiles$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Array<JobLog>>> {
      return getLogsTiles(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getLogsTiles$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getLogsTiles(params?: GetLogsTiles$Params, context?: HttpContext): Observable<Array<JobLog>> {
      return this.getLogsTiles$Response(params, context).pipe(
         map((r: StrictHttpResponse<Array<JobLog>>): Array<JobLog> => r.body)
      );
   }
}
